(function () {
  'use strict';

  function initSliders(root) {
    root.querySelectorAll('[data-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.slide'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-dot]'));
      if (slides.length < 2) return;
      var index = 0;
      var timer = null;
      var ms = parseInt(slider.dataset.interval, 10) || 5000;
      function go(n) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (n + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }
      function start() {
        stop();
        timer = setInterval(function () { go(index + 1); }, ms);
      }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { go(n); start(); });
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
  }

  function initCountdowns(root) {
    root.querySelectorAll('[data-countdown]').forEach(function (el) {
      var raw = (el.dataset.countdown || '').trim().replace(' ', 'T');
      var end = new Date(raw);
      var out = el.querySelector('[data-cd-out]');
      if (isNaN(end.getTime()) || !out) { el.hidden = true; return; }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end.getTime() - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        out.textContent = (d > 0 ? d + 'd : ' : '') + pad(h) + 'h : ' + pad(m) + 'm : ' + pad(s) + 's';
        if (diff === 0) { el.hidden = true; clearInterval(t); }
      }
      tick();
      var t = setInterval(tick, 1000);
    });
  }

  function initAutoSubmit(root) {
    root.querySelectorAll('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.form || document.getElementById(el.getAttribute('form'));
        if (form) form.submit();
      });
    });
  }

  function initFilters() {
    var f = document.querySelector('[data-filters]');
    if (f && window.innerWidth < 990) f.removeAttribute('open');
  }

  function swapMainImage(src) {
    var main = document.getElementById('MainMedia');
    if (!main || !src) return;
    var img = main.querySelector('img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = src;
  }

  function initProduct() {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        swapMainImage(btn.dataset.src);
        document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    var select = document.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var scope = select.closest('[data-product]') || document;
      var price = scope.querySelector('[data-price]');
      var compare = scope.querySelector('[data-compare]');
      if (price) price.textContent = opt.dataset.price || '';
      if (compare) compare.textContent = opt.dataset.compare || '';
      if (opt.dataset.image) swapMainImage(opt.dataset.image);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  function initRecommendations() {
    var el = document.querySelector('[data-recommendations]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function initAll(root) {
    initSliders(root);
    initCountdowns(root);
    initAutoSubmit(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initFilters();
    initProduct();
    initRecommendations();
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var menu = document.querySelector('.mobile-menu[open]');
      if (menu) menu.removeAttribute('open');
    }
  });
})();
